export interface Feed {
    id: number;
    type: FeedType;
    source: string| null;
    title: string | null;
    feed: string;
    link: string | null;
    date: string | null;
}

export interface FeedFilter {
    type: FeedType;
}

export enum FeedType {
    Internal = 'Internal',
    External = 'External'
}
